import React from 'react'
import styled from 'styled-components'
import Layout from '../../components/Layout'
import { useParams } from 'react-router-dom'
import { useRequest, useClient } from '../../fetchboi/hooks'
import { useCongress } from '../../congress/hooks'
import { motion } from 'framer-motion'
import Form from './Form'
import Header from './Header'
import { Alert } from 'rsuite'

const containerVariants = {
  hidden: { opacity: 1 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      when: "beforeChildren",
      staggerChildren: 0.2
    }
  }
}
const itemVariants = {
  hidden: { y: 20, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
  }
}

export default function ContactForm () {
  const { id, multiple } = useParams()
  const { congress } = useCongress()
  const [ timeStamp, setTimeStamp ] = React.useState(new Date().getTime())
  const [isLoading, setIsLoading] = React.useState(false)
  const [contact, loading] = useRequest({ url: `/messages/contacts/${id}` })
  const client = useClient()

  const handleSendMessage = async(values) => {
    setIsLoading(true)

    try {
      await client.post('/messages', {
        ...values,
        CongressSlug: congress.Slug,
        ContactUUID: id,
      })
      Alert.success('Mensaje enviado con éxito')
      setTimeStamp(new Date().getTime())
    } catch (e) {
      Alert.error('Se ha producido un error: '+e)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Layout.Container>
      <Layout.Loader loading={loading}/>
      <motion.div variants={containerVariants} initial="hidden" animate="visible">
        <Header name={contact && contact.Name} back={multiple !== '1'}/>
       
       
        <FormContainer variants={itemVariants}>
          <Title>¡Escríbenos!</Title>
          <SubTitle>Estaremos encantados de poder ayudarte</SubTitle>
          {isLoading ? 
            (<Layout.Loader loading={isLoading}/>)
          : (
            <Form onSubmit={handleSendMessage} key={timeStamp}/>
          )}
        </FormContainer>
       
      </motion.div>
    </Layout.Container>
  )
}

const FormContainer = styled(motion.div)`
  padding: 30px;
  margin-bottom: 18px;
  background: #FFF;
  box-shadow: 0 3px 20px rgba(197, 217, 232, 0.5);
  border-radius: 12px;
`

const Title = styled.p`
  font-size: 28px;
  line-height: 21px;
  text-align: center;
  color: #19A0FA;
  margin-bottom: 20px;
`

const SubTitle = styled.p`
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  color: #19A0FA;
  margin-bottom: 30px;
`